<template>
  <o-modal
    footer-variant="primary"
    width="352px"
    min-height="482px"
    z-index="$zindex-incoming-modal"
    :visible="modalVisible"
    :class="componentClassName"
    :footer-shadow="false"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    :show-close="true"
    :no-scroll="true"
    @close="handleModalCloseClick"
  >
    <div class="o-outgoing-call-modal__content">
      <div class="o-outgoing-call-modal__avartar">
        <div class="o-outgoing-call-modal__avartar-bg">
          <img src="@/images/calling-bg.svg" />
        </div>
        <div class="o-outgoing-call-modal__avartar-img">
          <img src="@/images/calling-avartar.svg" />
        </div>
      </div>
      <div class="o-outgoing-call-modal__info">
        <h3>{{ title }}</h3>
      </div>
      <div v-if="currentPhoneNumber" class="o-outgoing-call-modal__select-number">
        <m-form-input>
          <a-select-field
            id="o-outgoing-call-modal-select-number"
            v-model="selectedTelNumber"
            :options="telNumberListOptions"
          />
        </m-form-input>
      </div>
      <!-- <div class="o-outgoing-call-modal__current-number">
        <a-current-phone v-model="currentNumber" :disabled="calling" @change="currentPhoneChange">
          <template v-for="(item, index) in availableNumbers" :key="index">
            <option :value="item.value">{{ item.label }}</option>
          </template>
        </a-current-phone>
      </div> -->
    </div>
    <template #footer>
      <a-button
        v-if="!calling"
        id="o-outgoing-call-modal-button"
        class="o-outgoing-call-modal__button-call"
        variant="round"
        color="primary"
        icon="phone-outgoing-call"
        icon-color="white"
        label="発信"
        :inline="true"
        :disabled="!canMakeCall"
        @click="handleCallClick"
      />
      <a-button
        v-if="calling"
        id="o-outgoing-call-modal-hangup-button"
        class="o-outgoing-call-modal__button-hangup"
        variant="round"
        color="primary-red"
        icon="phone-hang-up-call"
        icon-color="white"
        label="キャンセル"
        :inline="true"
        @click="handleHangupClick"
      />
    </template>
    <teleport to="body">
      <o-modal
        id="outgoingCallModal_resultModal"
        v-model:visible="resultModalVisible"
        class="o-modal-remove-phone-number-confirmation"
        footer-variant="confirmation"
        width="442px"
        :footer-shadow="false"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        :show-close="false"
      >
        <template #title>{{ resultModalTitle }}</template>
        <a-text>
          <!-- eslint-disable -->
          <span v-html="resultModalContent" />
          <!-- eslint-enable -->
        </a-text>
        <template #footer>
          <a-button
            id="buttonResultOk"
            variant="block"
            color="primary"
            label="OK"
            size="small"
            @click="handleCloseResultModal()"
          />
        </template>
      </o-modal>
    </teleport>
  </o-modal>
</template>

<script>
import { mapModifiers } from '@/libs/component';
import OModal from '@/components/organisms/modal';
import ACurrentPhone from '@/components/atoms/current-phone';
import AButton from '@/components/atoms/button';
import { messageContent } from '@/common/messageContent.js';
import { customRequest } from '@/common/customRequest.js';
const UNSELECTED = 'unselected';

export default {
  name: 'o-outgoing-call-modal',
  components: {
    OModal,
    //ACurrentPhone,
    AButton,
  },
  mixins: [customRequest, messageContent],
  props: {
    class: {
      type: String,
      default: '',
    },
    modalVisible: {
      type: Boolean,
      default: false,
    },
    handleModalClose: {
      type: Function,
      default: () => {},
    },
    title: {
      type: String,
      default: '',
    },
    availableNumbers: {
      type: Array,
      default: new Array(0),
    },
    isCalling: {
      type: Boolean,
      default: false,
    },
    selectedNumber: {
      type: String,
      default: '',
    },
    currentPhoneNumber: {
      type: String,
      default: '',
    },
    currentUserInfo: {
      type: Object,
      default: null,
    },
  },
  emits: ['call', 'hangup', 'update:currentNumber', 'error:phone-number-suspended'],
  data() {
    return {
      telNumberListOptions: [{ label: '発信元番号選択', value: UNSELECTED }],
      selectedTelNumber: UNSELECTED,
      previousSelectedTelNumber: UNSELECTED,
      currentNumber: '',
      calling: false,
      resultModalTitle: '',
      resultModalContent: '',
      resultModalVisible: false,
    };
  },
  computed: {
    componentClassName() {
      const baseClassName = mapModifiers('o-outgoing-call-modal', this.calling ? 'calling' : '');
      return `${baseClassName} ${this.class}`.trim();
    },
    canMakeCall() {
      if (!this.currentPhoneNumber) return true;
      return !this.selectedTelNumber || this.selectedTelNumber === UNSELECTED ? false : true;
    },
  },
  watch: {
    selectedNumber(val, oldVal) {
      this.setSelectedNumber(this.selectedNumber);
    },
    isCalling(val) {
      this.calling = val;
    },
    modalVisible(val) {
      if (val) {
        this.fetchAvailableTelNumbers();
      }
    },
  },
  created() {
    this.fetchPreviousSelectedTelNumber();
  },
  mounted() {
    const vm = this;
    if (vm.selectedNumber) {
      this.setSelectedNumber(vm.selectedNumber);
    } else if (vm.availableNumbers && vm.currentNumber === '' && vm.availableNumbers.length > 0) {
      this.setSelectedNumber(vm.availableNumbers[0].value);
    }
    if (vm.isCalling) {
      vm.calling = vm.isCalling;
    }
  },
  methods: {
    async handleCallClick() {
      // 通話中の場合は発信不可
      const resultCheckCallingStatus = await this.postRequest('/home/checkCallingStatus');
      if (resultCheckCallingStatus.status !== 'success' || resultCheckCallingStatus.callingStatus) {
        this.resultModalTitle = messageContent.errorModalTitle;
        this.resultModalContent = messageContent.cannotCallDuringCall;
        this.resultModalVisible = true;
        return;
      }

      if (this.currentPhoneNumber) {
        // 外線
        this.postRequest('/numbermgmt/getStockTelNumberInfo', {
          telNumber: this.selectedTelNumber.replace('0', '+81'),
        })
          .then(e => {
            if (e.data) {
              if (e.data.stockTelNumberInfo) {
                // 電話番号が利用停止の場合は発信しない
                if (e.data.stockTelNumberInfo.status === 'suspended') {
                  this.$emit('error:phone-number-suspended');
                } else {
                  // 発信時の自番号を保存
                  this.postRequest('/home/updateOutgoingTelNumber', {
                    outgoingTelNumber: this.selectedTelNumber,
                  })
                    .then(res => {
                      if (res.status === 'success') {
                        this.$emit('call', this.selectedTelNumber);
                      } else {
                        throw new Error('Update data failed');
                      }
                    })
                    .catch(err => {
                      console.error(err);
                    });
                }
              }
            }
          })
          .catch(err => {
            console.error(err);
          });
      } else {
        // 内線
        this.$emit('call', this.selectedTelNumber);
      }
    },
    handleHangupClick() {
      this.calling = false;
      this.$emit('hangup');
    },
    setSelectedNumber(value) {
      this.currentNumber = value;
    },
    currentPhoneChange(e) {
      this.$emit('update:currentNumber', e.target.value);
    },
    handleModalCloseClick() {
      if (this.calling) {
        // should hangup first
        this.handleHangupClick();
        this.handleModalClose();
      } else {
        this.handleModalClose();
      }
    },
    fetchAvailableTelNumbers() {
      this.postRequest('/home/fetchAvailableTelNumbers')
        .then(res => {
          if (res.status === 'success') {
            const telNumbers = res.telNumbers;
            const telNumberListOptions = [{ label: '発信元番号選択', value: UNSELECTED }];
            let isSelectedNumberValid = false;
            for (const telNumber in telNumbers) {
              const label = telNumbers[telNumber] || '未設定';
              telNumberListOptions.push({ label: `${label}（${telNumber}）`, value: telNumber });
              if (telNumber === this.previousSelectedTelNumber) {
                isSelectedNumberValid = true;
              }
            }
            this.telNumberListOptions = telNumberListOptions;
            this.selectedTelNumber = isSelectedNumberValid ? this.previousSelectedTelNumber : UNSELECTED;
          } else {
            this.telNumberListOptions = [{ label: '発信元番号選択', value: UNSELECTED }];
            this.selectedTelNumber = UNSELECTED;
            throw new Error('Fetch data failed');
          }
        })
        .catch(err => {
          console.error(err);
        });
    },
    fetchPreviousSelectedTelNumber() {
      this.postRequest('/home/fetchPreviousSelectedTelNumber')
        .then(res => {
          if (res.status === 'success') {
            this.previousSelectedTelNumber = res.previousSelectedTelNumber || UNSELECTED;
            if (this.previousSelectedTelNumber !== UNSELECTED) {
              this.telNumberListOptions.push({ label: 'ダミー', value: this.previousSelectedTelNumber });
            }
          } else {
            throw new Error('Fetch data failed');
          }
        })
        .catch(err => {
          console.error(err);
        });
    },
    handleCloseResultModal() {
      this.resultModalVisible = false;
      this.resultModalTitle = '';
      this.resultModalContent = '';
    },
  },
};
</script>
